import { translate } from "@locales";

export function interpolatedText(key: string, amount?: number) {
  return translate(key, { interpolate: { amount: amount || 0 } });
};

export function interpolatedTextString(key: string, query?: string, status?: string) {
  return translate(key, { interpolate: { query: query || "", status: status || "" }});
};